import { render, staticRenderFns } from "./policycorner.vue?vue&type=template&id=d4a26c8a&scoped=true"
import script from "./policycorner.vue?vue&type=script&lang=js"
export * from "./policycorner.vue?vue&type=script&lang=js"
import style0 from "./policycorner.vue?vue&type=style&index=0&id=d4a26c8a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4a26c8a",
  null
  
)

export default component.exports